 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, callbacks = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId])
 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				var _m = moreModules[moduleId];

 				// Check if module is deduplicated
 				switch(typeof _m) {
 				case "object":
 					// Module can be created from a template
 					modules[moduleId] = (function(_m) {
 						var args = _m.slice(1), templateId = _m[0];
 						return function (a,b,c) {
 							modules[templateId].apply(this, [a,b,c].concat(args));
 						};
 					}(_m));
 					break;
 				case "function":
 					// Normal module
 					modules[moduleId] = _m;
 					break;
 				default:
 					// Module is a copy of another module
 					modules[moduleId] = modules[_m];
 					break;
 				}
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
 		while(callbacks.length)
 			callbacks.shift().call(null, __webpack_require__);
 		if(moreModules[0]) {
 			installedModules[0] = 0;
 			return __webpack_require__(0);
 		}
 	};

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// "0" means "already loaded"
 	// Array means "loading", array contains callbacks
 	var installedChunks = {
 		0:0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId])
 			return installedModules[moduleId].exports;

 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			exports: {},
 			id: moduleId,
 			loaded: false
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.loaded = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
 		// "0" is the signal for "already loaded"
 		if(installedChunks[chunkId] === 0)
 			return callback.call(null, __webpack_require__);

 		// an array means "currently loading".
 		if(installedChunks[chunkId] !== undefined) {
 			installedChunks[chunkId].push(callback);
 		} else {
 			// start chunk loading
 			installedChunks[chunkId] = [callback];
 			var head = document.getElementsByTagName('head')[0];
 			var script = document.createElement('script');
 			script.type = 'text/javascript';
 			script.charset = 'utf-8';
 			script.async = true;

 			script.src = __webpack_require__.p + "" + chunkId + ".js/" + ({"1":"vendor","2":"game","3":"cms/cases","4":"commons","5":"teacher/session-overview","6":"business-model-test","7":"teacher/create-session","8":"legal/terms-of-use","9":"legal/privacy-policy","10":"legal/disclaimer","11":"legal/cookie-policy","12":"teacher/sessions-overview","13":"marketing/contact","14":"verify-email","15":"teacher/teacher-platform","16":"teacher/instruction-video","17":"teacher/edit-profile","18":"teacher/course-material","19":"reset-password","20":"register","21":"outdated","22":"marketing/teacher-platform","23":"marketing/faq","24":"login","25":"index","26":"errors/404","27":"cms/website","28":"cms/login","29":"change-password-token","30":"admin/teacher-test","31":"admin/css-components","32":"admin/api-playground","33":"cms/feedback","34":"cms/cases-overview"}[chunkId]||chunkId) + "." + {"1":"73a7572c729658733ffd","2":"514c88be2e0ec42c9721","3":"48104ba6ee08e057021a","4":"1bebbabf34ac93e4a3dd","5":"0293a83d5c35b070bacf","6":"bd8b014819a329d19e38","7":"c3bfffbe040c5e104ee3","8":"2a477aa5c8fe8a2f86df","9":"10b70d0d2b71c73b2bf5","10":"a1ec01d9480c7c3668bc","11":"4dd44cb2a0a086b0d066","12":"66f3a434d358ccb0666a","13":"c2092b9e01bc499f2d7c","14":"d74d28a4b04bdf0ed456","15":"d74fe99007c8065d834f","16":"99189bcf1a5801fd17a7","17":"cdc55beb89b842e1bde0","18":"3c85273cf3a739ef404f","19":"96c3e02dc7f741191ae3","20":"04edf2fa1faac00b2193","21":"4809ae445a96cf2e2321","22":"a6cf83e466527a59090f","23":"0d60fdce2669b8c7bf9c","24":"716269f32be02407fb98","25":"e1bb4378d1768ed94afe","26":"3de96afeaf1369e36362","27":"c6ec003272e0c60acfdd","28":"f4331acd4ecb2eff6cc4","29":"6a76f3802c7830659cfe","30":"faff963f550c3d259488","31":"765d44db3112391d96cd","32":"a3499fa9f929dcdfc6f8","33":"c3d8fcdd01d146972721","34":"b5deead8bb2bd0f8390c"}[chunkId] + ".js";
 			head.appendChild(script);
 		}
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// __webpack_public_path__
 	__webpack_require__.p = "/";



// WEBPACK FOOTER //
// webpack/bootstrap 7431fe90a4f5bd9c7548